import styled from '@emotion/styled';

export const SContainer = styled.div`
  padding: 20px;
  background: #f2f2f2;
  min-height: 100%;
  display: flex;
  flex-direction: column;
`;

export const SHeader = styled.header`
  display: flex;
  justify-content: space-between;
  position: relative;
  height: 34px;
  align-items: center;
`;

export const SContent = styled.div`
  flex-grow: 1;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 34px;
`;

export const SLanguageSwitcher = styled.div`
  flex-shrink: 0;
  margin-left: 16px;
`;
